import React from 'react';
import { Controller, FieldPath, FieldValues } from 'react-hook-form';
import { InputLabel } from '@material-ui/core';
import { InputProps } from './types';
import { StyledQuestionFieldContainer } from '../Questionnaires/QuestionnairePage/components/QuestionViewerEditor/QuestionEditor/styles';
import ConditionSelector from '../ConditionSelector';
import { ErrorMessage } from '../Services/styled-components';

function ConditionSelectorEditor<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>({
  control,
  name
}: InputProps<TFieldValues, TName>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange }, fieldState }) => (
        <StyledQuestionFieldContainer>
          <InputLabel error={Boolean(fieldState.error)}>Condition</InputLabel>
          <ConditionSelector value={value} onChange={onChange} />
          <ErrorMessage>{fieldState.error?.message}</ErrorMessage>
        </StyledQuestionFieldContainer>
      )}
    />
  );
}

export default ConditionSelectorEditor;
